<template>
  <transition name="channel-flow-modal-fade">
    <div v-if="isVisible" class="channel-flow-modal-overlay">
      <div class="channel-flow-modal-content">
        <!-- Header com barra de progresso -->
        <div class="channel-flow-modal-header">
          <div class="channel-flow-header-content">
            <h2 class="channel-flow-modal-title">{{ steps[currentStep].title }}</h2>
            <div class="channel-flow-progress-bar">
              <div class="channel-flow-progress-fill" :style="{ width: progressWidth }"></div>
            </div>
          </div>
          <button @click="closeModal" class="channel-flow-close-button">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <!-- Conteúdo do modal -->
        <div class="channel-flow-modal-body">
          <ChannelSelection
            v-if="currentStep === 0"
            v-model="new_channel"
            :channelConfigs="channelConfigs"
            @channel-selected="nextStep"
          />

          <CompanyInformation
            v-if="currentStep === 1"
            v-model="companyInfo"
            :sectors="sectors"
            :selectedChannel="new_channel"
            @next="nextStep"
          />

          <UserCreation
            v-if="currentStep === 2"
            :teams="companyInfo.teams"
            @update-users="updateUserList"
          />

          <ChannelActivation
            v-if="currentStep === 3"
            :selectedChannel="new_channel"
            :companyInfo="companyInfo"
            :userList="userList"
            :payload="generatePayload()"
            @previous="prevStep"
            @finished="handleFinish"
          />
          
          <ConfirmationMessage  
            v-if="currentStep === 4" 
            @close="closeModal"
          />
        </div>

        <!-- Botões de navegação -->
        <div class="channel-flow-modal-footer" v-if="currentStep > 0 && currentStep < steps.length - 1">
          <button @click="prevStep" class="channel-flow-btn-secondary">{{ getTranslations("expression_113") }}</button>
          <!-- <button v-if="currentStep === 3" @click="nextStep" class="channel-flow-btn-next">Pular Ativação</button> -->
          <button
  :disabled="!canProceed || isLoading"
  @click="nextStep"
  class="channel-flow-btn-next"
>
  {{ isLoading ? getTranslations("expression_1401") : getTranslations("expression_1368") }}
</button>

        </div>

      </div>
    </div>
  </transition>
</template>


<script>
import ChannelSelection from "../modals/sections/ChannelSelection.vue";
import CompanyInformation from "../modals/sections/CompanyInformation.vue";
import UserCreation from "../modals/sections/UserCreation.vue";
import ChannelActivation from "../modals/sections/ChannelActivation.vue";
import ConfirmationMessage from "../modals/sections/ConfirmationMessage.vue";
import "../../assets/css/Channel-Flow/StepByStepModal.css"
export default {
  props: {
    isVisible: Boolean,
  },
  components: {
    ChannelSelection,
    CompanyInformation,
    UserCreation,
    ChannelActivation,
    ConfirmationMessage,
  },
  data() {
    return {
      isLoading: false,
      new_channel: null,
      companyInfo: { name: "", teams: [], sector: "" },
      userList: [],
      currentStep: 0,
      // steps: [
      //   { title: "Selecione o Canal" },
      //   { title: "Informações da Empresa" },
      //   { title: "Cadastro de Usuários" },
      //   { title: "Ativação do Canal" },
      //   { title: "Confirmação" },
      // ],
      sectors: [
        "Varejo",
        "Saúde",
        "Educação",
        "Tecnologia",
        "Serviços Financeiros",
        "Logística",
        "Imobiliário",
        "Alimentício",
        "Construção Civil",
      ],
      channelConfigs: {
        data: {
          
          // CHANNEL_TYPES AJUSTADO CORRETAMENTE
          channel_types: [
            { id: 0, type_key: 0, integration_key: 15, name: "WhatsApp Web" },
            { id: 0, type_key: 0, integration_key: 12, name: "WhatsApp Cloud API" },
            { id: 2, type_key: 2, integration_key: 13, name: "Instagram" },
            { id: 3, type_key: 3, integration_key: 14, name: "Facebook" },
          ],


        },
      },
    };
  },
  mounted() {
  this.resetModal();
},

  computed: {
    steps() {
    return [
      { title: this.getTranslations("expression_1363") || "Selecione o Canal" },
      { title: this.getTranslations("expression_1364") || "Informações da Empresa" },
      { title: this.getTranslations("expression_1365") || "Cadastro de Usuários" },
      { title: this.getTranslations("expression_1366") || "Ativação do Canal" },
      { title: this.getTranslations("expression_1367") || "Confirmação" },
    ];
  },
    canProceed() {
      return true;
    },
    progressWidth() {
      return `${((this.currentStep + 1) / this.steps.length) * 100}%`;
    },
  },
  methods: {
  prevStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
    }
  },
  handleFinish() {
    this.currentStep = 4; // tela de confirmacao
  },
  async activateChannel() {
    this.isLoading = true;

    const integrationKeyMap = {
      0: 15, // WhatsApp Comum
      1: 12, // WhatsApp Oficial
      2: 13, // Instagram
      3: 14, // Messenger
    };

    const payload = {
      company: {
        name: this.companyInfo.name,
        address: {
          zip_code: null,
          country: null,
          district: null,
          city: null,
          state: null,
          number: null,
          street: null,
        },
      },
      type_key: this.new_channel.type_key,
      integration_key: integrationKeyMap[this.new_channel.type_key] || null,
      departments: this.companyInfo.teams.map((team, index) => ({
        name: team.name,
        position: index,
        id: null,
      })),
      users: this.userList,
    };

    try {
      const response = await api.post("/channels/flow-new-channel", payload);

      if (response.status === 201) {
        this.$toast.success(this.getTranslations("expression_1396"));

        // this.$emit("finished");
        this.handleFinish();

      } else {
        
        this.$toast.error(this.getTranslations("expression_1397"));
      }

    } catch (error) {
      console.error(this.getTranslations("expression_1398"), error);

      if (error.response && error.response.data && error.response.data.message) {
        this.$toast.error(`Erro: ${error.response.data.message}`);
      } else {
        this.$toast.error(this.getTranslations("expression_1399"));
      }

    } finally {
      this.isLoading = false;
    }
  },
    async nextStep() {
      if (this.currentStep === 0) {
        if (!this.new_channel.name || this.new_channel.type_key === null) {
          this.$toast.error(this.getTranslations("expression_1369") );
          return;
        }
      }

      if (this.currentStep === 1) {
        if (!this.companyInfo.name.trim()) {
          this.$toast.error(this.getTranslations("expression_1370") );
          return;
        }
        if (this.companyInfo.teams.length === 0) {
          this.$toast.warning(this.getTranslations("expression_1371") );
          return;
        }
      }

      if (this.currentStep === 2) {
        if (this.userList.length === 0) {
          this.$toast.error(this.getTranslations("expression_1372") );
          return;
        }

      
      }
      if (this.currentStep === 3) {
    await this.activateChannel(); // ativa o canal diretamente
    return; // não incrementa o step manualmente, pois handleFinish já faz isso
  }

      this.currentStep++;
    },

    updateUserList(users) {
      this.userList = users;
    },

    generatePayload() {
  const integrationKeyMap = {
    0: 15, // WhatsApp Comum
    1: 12, // WhatsApp Oficial
    2: 13, // Instagram
    3: 14, // Messenger
  };

  return {
    company: {
      name: this.companyInfo.name,
      address: {
        zip_code: null,
        country: null,
        district: null,
        city: null,
        state: null,
        number: null,
        street: null,
      },
    },
    type_key: this.new_channel.type_key,
    integration_key: this.new_channel.integration_key, 
    departments: this.companyInfo.teams.map((team, index) => ({
      name: team.name,
      position: index,
      id: null,
    })),
    users: this.userList,
  };
},

    openModal() {
      
      this.$emit("open");
    },

    closeModal() {
      this.resetModal();
  this.$emit("close");
},

    resetModal() {
      this.currentStep = 0;
      this.new_channel = null;
      this.companyInfo = { name: "", teams: []};
      this.userList = [];
    },
  },
};
</script>







